<!-- <div class="container">
  <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
      <div class="custom-control custom-checkbox chkbox mb-2">
        <input type="checkbox" class="custom-control-input mgntp10" id="switch" value="isChecked" name="in_contract"
          [(ngModel)]="isChecked" (ngModelChange)="getSwitchDate()" />
        <label class="custom-control-label font20" for="switch">Start service by {{switchDate}}</label>
        <div style="display: inline;" class="pull-right datepick" id="datepick3">
          <my-date-picker name="mydate" class="date-format" required [options]="myDatePickerOptions" id="date"
            [(ngModel)]="model" (ngModelChange)="getDate();" placeholder="MM/DD/YYYY" required></my-date-picker>
        </div>
      </div>
      <div class="container col-sm-8 webview text-center">
        <button class="btn next mr-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': user_bot}"
          (click)="next();">Next</button></div>
    </div>
  </div>
</div> -->
<div class="container col-sm-8 pt-5 webview text-center pb-5" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div _ngcontent-c5="" class="col-md-5 col-lg-4 m-auto" id ="comdatepick">
      <div>
        <my-date-picker name="mydate" class="date-format" required [options]="myDatePickerOptions" id ="date"
        [(ngModel)]="model" (ngModelChange) = "getDate();" placeholder = "MM/DD/YYYY" required></my-date-picker>
      </div>                  
  </div>
  <button *ngIf="showbutton" class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': user_bot}" (click)="next();">Next</button>
</div>
  <div class="container mobileview px-0 mb-4 mt-4" [attr.id]="questionObj._id" style="float:left;">
    <div class="d-flex h-100 row col-sm-12 pr-0">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
        <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-9 col-9 px-0 my-auto">
        <div class="arrow_box">
          <h1 class="questionMob text-left">{{question}}</h1>
        </div>
      </div>
    </div>
    <div class="col-sm-12 m-auto">
      <div class="col-12 px-0 pull-right">
        <!-- <div class="custom-control custom-checkbox chkbox mb-2">
          <input type="checkbox" style="display: inline-block;" class="custom-control-input mgntp10" id="switch_mob"
            value="isChecked" name="in_contract" [(ngModel)]="isChecked"
            (ngModelChange)="getSwitchDate()" />
          <label style="display: inline-block;" class="custom-control-label font20" for="switch_mob">Start service by
            {{switchDate}}
          </label>
          <div style="display: inline-block;" class="pull-right mt-1" id="datepick3">
            <my-date-picker style="display: inline-block; right:0;" name="mydate" class="date-format" required
              [options]="myDatePickerOptions" id="date" [(ngModel)]="model" (ngModelChange)="getDate();"
              placeholder="MM/DD/YYYY" required></my-date-picker>
          </div>
        </div> -->
        <div class="col-9 offset-col-3 mb-2 px-0 pull-right" id ="comdatepick">
          <my-date-picker name="mydate" type="date" [options]="myDatePickerOptions" [(ngModel)]="model"
          (ngModelChange)="getDate();" placeholder="MM/DD/YYYY" required></my-date-picker>
        </div>
      </div>
      <div class="col-12 pr-0" style="width:100% !important; text-align: right;">
        <div *ngIf="user_bot" class="mb-3 ash_box text-right">
          <h1 class="ansMob text-right">{{ans_switch_date}}</h1>
        </div>
      </div>
    </div>
    <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
      <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
          <img style="width:100%;" src="assets/images/logo-charcoal.png" />
      </div>
      <div class="col-sm-2 col-2 px-0 my-auto">
          <div class="arrow_box">
              <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
          </div>
      </div>
    </div>
  </div>